import React from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../../../utils/mask.js";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import {getCities, getCountries} from "../../../../../../utils/location-utils.js";
import InputCheckbox from "../../../../../../components/input/input-checkbox.jsx";

const GeneralFilter = ({filter, onChange, onChangeCustom}) => {
    return (
        <SentryRow>
            <div className="col-span-4">
                <InputForm
                    id="cpf"
                    label="CPF"
                    value={filter.cpf}
                    onChange={onChange}
                    onBlur={onChange}
                    mask={MaskDefault.cpf}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="rg"
                    label="RG"
                    value={filter.rg}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="cnh"
                    label="CNH"
                    value={filter.cnh}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-6">
                <InputForm
                    id="name"
                    label="Nome"
                    value={filter.name}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-3">
                <InputForm
                    id="socialName"
                    label="Nome social"
                    value={filter.socialName}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-3">
                <InputForm
                    id="nickname"
                    label="Apelido"
                    value={filter.nickname}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <SelectComponent
                    id="sex"
                    value={filter.sex}
                    options={optionsUtils.sex2}
                    label="Sexo"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "sex")}
                />
            </div>
            <div className="col-span-4">
                <SelectComponent
                    id="maritalStatus"
                    value={filter.maritalStatus}
                    options={optionsUtils.maritalStatus}
                    label="Estado civil"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "maritalStatus")}
                />
            </div>
            <div className="col-span-4">
                <SelectComponent
                    id="nationality"
                    label="Nacionalidade"
                    isAsync={true}
                    loadOptions={getCountries}
                    defaultOptions={[]}
                    value={optionsUtils.getValue(filter.nationality)}
                    onChange={(value) => onChangeCustom(value?.value ?? "", "nationality")}
                />
            </div>

            <div className="col-span-4">
                <SelectComponent
                    id="cityOfBirth"
                    loadOptions={getCities}
                    value={optionsUtils.getValue(filter.cityOfBirth)}
                    isAsync={true}
                    label="Naturalidade"
                    onChange={(value) => onChangeCustom(value?.value ?? "", "cityOfBirth")}
                    cacheOptions
                    defaultOptions={[]}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="mother"
                    label="Nome da mãe"
                    value={filter.mother}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="father"
                    label="Nome do pai"
                    value={filter.father}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    type={"number"}
                    id="dtBirth_min"
                    label="Idade máxima"
                    value={filter.dtBirth_min}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    type={"number"}
                    id="dtBirth_max"
                    label="Idade mínima"
                    value={filter.dtBirth_max}
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="phone"
                    value={filter.phone}
                    label="Telefone"
                    onBlur={onChange}
                    onChange={onChange}
                    mask={MaskDefault.phone}
                />
            </div>
            <div className="col-span-12 flex gap-4">
                <InputCheckbox
                    id="alcoholDrugDependency"
                    label="Dependência álcool/drogas"
                    checked={!!filter.alcoholDrugDependency}
                    onChange={({target: {checked}}) => onChangeCustom(checked, "alcoholDrugDependency")}
                />
                <InputCheckbox
                    id="mentalDisorder"
                    label="Transtorno mental"
                    checked={!!filter.mentalDisorder}
                    onChange={({target: {checked}}) => onChangeCustom(checked, "mentalDisorder")}
                />
            </div>
        </SentryRow>
    );
};

export default GeneralFilter;
